import { render, staticRenderFns } from "./ProjectClassify.vue?vue&type=template&id=ec7f24b8&scoped=true&"
import script from "./ProjectClassify.vue?vue&type=script&lang=js&"
export * from "./ProjectClassify.vue?vue&type=script&lang=js&"
import style0 from "./ProjectClassify.vue?vue&type=style&index=0&id=ec7f24b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7f24b8",
  null
  
)

export default component.exports